import {PatchOdontoConfirm} from 'domain/usecases';
import {RemotePatchOdontoConfirm} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePatchOdontoConfirmBooked = (): PatchOdontoConfirm =>
	new RemotePatchOdontoConfirm(
		makeBFFApiUrl(BookedFlowEndPoints.odontoBookedConfirm),
		makeAuthorizeHttpClientDecorator(),
	);
